import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import planningImg from "../../assets/images/home/planning.svg";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    // const { data, colors } = props
    const data = props.data;
    let row = [];
    let percent = (data) => {
        let sumpercent = 0
        if (data > 0) {
            sumpercent = ((data / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    for (var i = 0; i < data.series.length; i++) {
        row.push(
            <Box key={data.series[i].id} display="flex" alignItems="center">
                <Box sx={{ width: "10%" }} mr="2.5">
                    <div className="bar-legend-square" style={{ backgroundColor: data.options.colors[i] }}></div>
                </Box>
                <Box sx={{ width: "50%", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.options.labels[i]}</Typography></Box>
                <Box sx={{ width: "20%" }} px="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={500}> {data.series[i]}</Typography></Box>
                <Box sx={{ width: "20%" }} pl="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={300}>({data.series[i]}%)</Typography></Box>
            </Box>
        );
    }
    return (row)
}

export default function GoalsStatus(props) {
    const { t } = useTranslation();
    const { datas, dataPA } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState([]);
    const [dataBarChart, setDataBarChart] = React.useState([]);
    // useEffect(() => {
    //     mapping()
    // }, [datas]);
    // let sumScore = (data) => {
    //     let totals = 0
    //     data.rb_condition.map((data) => { totals = totals + calculateScore(data) })
    //     return totals
    // }
    // let totalScore = () => {
    //     let totals = 0
    //     if (typeList.length > 0) {
    //         typeList.map((data) => { totals = totals + Number(data?.data[0]) })
    //     }
    //     return totals.toFixed(2)
    // }
    // let calculateScore = (data) => {
    //     let sum = eval(data.calculate_score)
    //     let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
    //     return scores
    // }
    // let sumScoreAccumulateUse = (data) => {
    //     let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
    //     for (let index = 0; index <= data.rb_condition.length - 1; index++) {
    //         totals = totals + Number(calculateScore(data.rb_condition[index]))
    //     }
    //     return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    // }
    // const mapping = () => {
    //     if (datas !== undefined && datas !== null && datas !== "null") {
    //         var typeData = []
    //         var score = 0
    //         let colors = []
    //         let sumData = []
    //         for (let index = 0; index <= datas.length - 1; index++) {
    //             for (let indexs = 0; indexs <= dataPA.ratio_data.length - 1; indexs++) {
    //                 if (dataPA.ratio_data.length > 0) {
    //                     if (datas[index].serial === Object.keys(dataPA.ratio_data[indexs])[0]) {
    //                         typeData.push({ name: datas[index].description, data: [sumScoreAccumulateUse(datas[index])] })
    //                         sumData.push({
    //                             name: datas[index]?.description,
    //                             data: [sumScoreAccumulateUse(datas[index])],
    //                             configuration: datas[index]?.configuration
    //                         })
    //                         let criterionScore = dataPA.ratio_data[indexs][Object.keys(dataPA.ratio_data[indexs])].criterion_score
    //                         setCriterionScore(Number.isNaN(Number(criterionScore)) ? 0 : Number(criterionScore));
    //                         console.log(JSON.parse(datas[index].configuration)['background-color']);
    //                         colors.push(JSON.parse(datas[index].configuration)['background-color'])
    //                     }

    //                 }
    //             }
    //         }
    //         setTypeList(typeData)
    //         setColor(colors)
    //         setDataBarChart(sumData)
    //     }
    // }

    let chartOptions = {
        type: "donut",
        series: [2, 1, 3],
        options: {
            unit: "คะแนน",
            chart: {
                type: "donut",
            },
            colors: [
                cssVariables.barChart.donutHomeKpi["100"],
                cssVariables.barChart.donutHomeKpi["200"],
                cssVariables.barChart.donutHomeKpi["300"],
            ],
            labels: ['Planning', 'In Progress', 'Completed'],
            plotOptions: {
                pie: {
                    startAngle: 0,
                    endAngle: 360,
                    expandOnClick: true,
                    offsetX: 0,
                    offsetY: 0,
                    customScale: 1,
                    dataLabels: {
                        offset: 0,
                        minAngleToShowLabel: 10
                    },
                    donut: {
                        size: '70%',
                        background: 'transparent',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                                offsetY: 25,
                                formatter: () => 'Total Goals'
                            },
                            value: {
                                show: true,
                                fontSize: '36px',
                                fontFamily: "Kanit",
                                fontWeight: 600,
                                color: undefined,
                                offsetY: -15,
                                formatter: function (val) {
                                    return val
                                }
                            },
                            total: {
                                show: true,
                                showAlways: true,
                                fontSize: '16px',
                                fontFamily: "Kanit",
                                fontWeight: 300,
                                color: '#A3A3A3',
                                background: "#fff",
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce((a, b) => {
                                        return a + b
                                    }, 0)
                                }
                            }
                        }
                    },
                }
            },
            stroke: {
                width: 0,
                colors: ["#fff"],
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                shared: true,
                followCursor: false,
                intersect: false,
                inverseOrder: false,
                custom: undefined,
                fillSeriesColor: false,
                theme: false,
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                style: {
                    fontSize: '16px',
                    fontFamily: "Kanit",
                    fontWeight: 300,
                },
                x: {
                    show: true,
                },
                y: {
                    title: {
                        formatter: (seriesName) => seriesName + ":",
                    },
                    style: {
                        fontSize: '16px',
                        fontFamily: "Kanit",
                        fontWeight: 300,
                    },
                    formatter: function (val) {
                        return val;
                    },
                },
                marker: {
                    show: true,
                },
                items: {
                    display: "flex",
                },
                fixed: {
                    enabled: false,
                    position: 'topRight',
                    offsetX: 0,
                    offsetY: 0,
                },
            },
            fill: {
                opacity: 1,
                // type: ['solid', 'gradient'],
                // colors: '#F0F0F0'
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    }
                }
            }],
            legend: {
                show: false,
                position: "right",
                offsetY: 0,
                height: 200,
                // horizontalAlign: "left",
                // offsetX: -33,
                // offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                        " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
                        "</span>"
                    );
                },
            },
        },
    };

    return (
        <Box px={2} pt={1}>
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0" }} style={{ "padding-bottom": "0px" }}>
                {/* <Box>
                      <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                      <Typography>{t("home.label.nodata")}</Typography>
                    </Box> */}
                <Grid container mb={2}>
                    <Grid item lg={6} xs={10}>
                        <Typography fontSize={24} lineHeight="26.4px" fontWeight={500} color="#404349" sx={{ textAlign: "left" }}>
                            Goals Status
                        </Typography>
                    </Grid>
                </Grid>
                <Box display="flex" alignItems="center" width="100%" >
                    <Box sx={{ ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                        <ApexCharts
                            style={{ width: "280px", height: "210px" }}
                            options={chartOptions.options}
                            series={chartOptions.series}
                            type={chartOptions.type}
                            responsive={chartOptions.responsive}
                            labels={chartOptions.labels}
                        // maxHeight="100%"
                        // maxWidth="100%"
                        // height="200px"
                        ></ApexCharts>
                    </Box>
                    <Box sx={{ width: "calc(100% - 280px)" }}>
                        <Box sx={{ "margin-left": "-50px", width: "calc(100% + 15px)" }}>
                            <Box item lg={12} xs={12}>
                                <BarLegend data={chartOptions}></BarLegend>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </CardContent >
        </Box >
    )
}

